import React from 'react'
import { Link, LinkProps } from 'react-router-dom'
import classNames from 'classnames'

import type { LinkButtonProps } from './link-button.types'
import { Icon } from '@percent/lemonade'
import styles from './link-button.module.scss'

function DisabledLink({ to: _to, children, className, ...props }: LinkProps) {
  return (
    <a
      {...props}
      className={classNames(className, styles.disabled)}
      href={undefined}
      onClick={(e) => e.preventDefault()}
    >
      {children}
    </a>
  )
}

export const LinkButton = React.forwardRef<HTMLAnchorElement, LinkButtonProps>(
  (
    {
      variant = 'primary',
      size = 'medium',
      shape = 'default',
      stretch,
      disabled,
      startIcon,
      endIconSize,
      endIcon,
      startIconSize,
      children,
      'data-testid': dataTestId,
      ...linkProps
    },
    ref
  ) => {
    const Component = disabled ? DisabledLink : Link

    return (
      <Component
        {...linkProps}
        ref={ref}
        className={classNames(
          styles.linkButton,
          styles[`color-${variant}`],
          styles[`size-${size}`],
          styles[`shape-${shape}`],
          {
            [styles.stretch]: stretch,
          }
        )}
        data-testid={dataTestId}
      >
        <span className={styles.contentWrapper}>
          {startIcon && (
            <Icon name={startIcon} color="inherit" size={startIconSize ?? 6} />
          )}
          <span>{children}</span>
          {endIcon && !startIcon && (
            <Icon name={endIcon} color="inherit" size={endIconSize ?? 6} />
          )}
        </span>
      </Component>
    )
  }
)

LinkButton.displayName = 'LinkButton'
